import { Loader } from "@/components/display";
import { AuthProvider, useAuthContext } from "@/features/auth/contexts/auth-context";
import { CajaContextProvider, useCajaContext } from "@/features/cajas/caja-actual/contexts/caja-context";
import { ConfigurationProvider } from "@/features/configuration/contexts/configuration-context";
import { ParamsProvider } from "@/features/configuration/contexts/params-context";
import { MonetizacionProvider } from "@/features/monetizacion/contexts/monetizacion-context";
import useInitMonetizacion from "@/features/monetizacion/hooks/use-init-monetizacion";
import LoginPage from "@/pages/auth/login";
import SetPasswordPage from "@/pages/auth/set-password";
import ErrorPage from "@/pages/error";
import InitialMonetizacionPage from "@/pages/monetizacion/initial-monetizacion";
import { Permiso } from "@/shared/types/permiso";
import { Outlet } from "react-router";

export default function ContextLayout() {
    return <AuthProvider>
        <CajaContextProvider>
            <ContextLayoutContent />
        </CajaContextProvider>
    </AuthProvider>
}

function ContextLayoutContent() {
    const { isLoginError, isLogingIn, isLoggedIn, authData, hasPermisos } = useAuthContext();
    const { loading: isCajaLoading, error: isCajaError } = useCajaContext();
    const { isMonetizacionSet, loading: isMonetizacionLoading, error: isMonetizacionError, cotizacion, monedas, transferenciaMetodos } = useInitMonetizacion();

    // RootAdmin puede gestionar organizaciones sin monetización configurada
    const isRootAdmin = hasPermisos(Permiso.ManageOrganizaciones);

    if (isLogingIn || isMonetizacionLoading || isCajaLoading) return <Loader height={"100vh"} />
    if (isLoginError || isMonetizacionError || isCajaError) return <ErrorPage />
    if (!isLoggedIn) return <LoginPage />
    if (authData.isTemporal) return <SetPasswordPage />
    if (!isMonetizacionSet && !isRootAdmin) return <InitialMonetizacionPage />

    return <ConfigurationProvider>
        <ParamsProvider>
            <MonetizacionProvider cotizacion={cotizacion} monedas={monedas} transferenciaMetodos={transferenciaMetodos}>
                <Outlet />
            </MonetizacionProvider>
        </ParamsProvider>
    </ConfigurationProvider>
}